/**
 * @generated SignedSource<<2635412e455864838f74ea01cb54dade>>
 * @relayHash 98c0247ca90c6de40c2d21a99ee03767
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f60e3e0109779754ea40af453ec7985e44abd944bad136ca86c20562c6a0c32a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { AsyncMenuWithQueryQuery } from './AsyncMenuWithQueryQuery.graphql';

const node: PreloadableConcreteRequest<AsyncMenuWithQueryQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f60e3e0109779754ea40af453ec7985e44abd944bad136ca86c20562c6a0c32a",
    "metadata": {},
    "name": "AsyncMenuWithQueryQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
